import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

export function formatPlayTime(value) {
    if (value == null || value === "") return "—";
    const d = dayjs(value);
    return d.isValid() ? d.format("YYYY-MM-DD HH:mm") : "—";
}

export function playDurationMs(row) {
    const firstMs = row?.firstPlayedAt != null ? Number(row.firstPlayedAt) : NaN;
    const lastMs = row?.lastPlayedAt != null ? Number(row.lastPlayedAt) : NaN;
    if (!Number.isFinite(firstMs) || !Number.isFinite(lastMs) || lastMs < firstMs) {
        return null;
    }
    return lastMs - firstMs;
}

export function formatDurationMs(ms) {
    if (ms == null || !Number.isFinite(ms) || ms < 0) return "—";
    const totalDays = Math.floor(ms / 86_400_000);
    if (totalDays < 1) return "<1d";
    if (totalDays < 30) return `${totalDays}d`;
    const months = Math.floor(totalDays / 30);
    if (months < 12) return `${months}mo`;
    const years = Math.floor(months / 12);
    const remMonths = months % 12;
    return remMonths > 0 ? `${years}y ${remMonths}mo` : `${years}y`;
}

/** First / last play stacked in one column, plus last − first duration. */
export function promotionPlayTimeColumns() {
    return [
        {
            field: "playRange",
            headerName: "First / Last play",
            width: 160,
            sortable: false,
            valueGetter: (_value, row) => row?.lastPlayedAt ?? row?.firstPlayedAt ?? null,
            renderCell: (params) => (
                <Box sx={{ py: 0.5, lineHeight: 1.25 }}>
                    <Typography variant="body2" component="div" noWrap>
                        {formatPlayTime(params.row?.firstPlayedAt)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" component="div" noWrap>
                        {formatPlayTime(params.row?.lastPlayedAt)}
                    </Typography>
                </Box>
            ),
        },
        {
            field: "playDurationMs",
            headerName: "Duration",
            width: 100,
            sortable: false,
            valueGetter: (_value, row) => playDurationMs(row),
            valueFormatter: (value) => formatDurationMs(value),
        },
    ];
}
